import { createSlice,createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import {BASE_URL} from '../../utils/commonUrl'
const initState = {
    isLoading:false,
    message:'',
    quaters:[]
}

export const fetchQuater = createAsyncThunk('quater/getall', async () => {
    const response = await axios.get(`${BASE_URL}/api/quarter`)
    return response.data
  })


let userSlice = createSlice({
  name:'quater',
  initialState:initState,
  extraReducers:(builder)=>{
      builder
      .addCase(fetchQuater.pending,(state)=>{
          state.isLoading = true
      })
      .addCase(fetchQuater.fulfilled,(state,action)=>{
          state.isLoading = false
          state.quaters = action.payload
      })
      .addCase(fetchQuater.rejected,(state,payload)=>{
          state.isLoading = false
          state.message = payload.data.message
      })

  },
  reducers:{
      
  
  }
})

//export const {} = userSlice.actions;

export default userSlice.reducer;